'use client';
import React from 'react'
import RoundedIcon from '../RoundedIcon/RoundedIcon'
import { Icon } from '@phosphor-icons/react'
import { useIsLg } from '@/contexts/BreakpointContext';
interface SubheadingProps {
	heading: string
	text: string
	textColor?: string
	icon?: Icon
}



const Benefits: React.FC<SubheadingProps> = ({
	heading,
	text,
	textColor = "text-text-quaternary",
	icon
}) => {
	const isLg = useIsLg();

	return (
		<div className="
			flex flex-row flex-grow
			w-[18rem] max-w-full 
			tb:max-w-[30.6875rem]
			items-center justify-center
			">
			<div className=
				{`
				flex flex-col
				gap-[1.25rem]
				lg:gap-[1.5rem]
				items-center
				py-0
				lg:py-[0.5rem]
				text-center
			`}
			>
				{icon && (
					<RoundedIcon size={isLg ? 64 : 48} theme="dark" className="rounded-full">
						{React.createElement(icon, { className: "text-graphics-reversed" })}
					</RoundedIcon>
				)}

				<p className={`
				text-28-to-20--neue-june
				${textColor === 'text-text-quaternary' ? 'text-text-primary' : textColor}
				w-full
				`}
				>
					{heading}
				</p>

				<p className={`
				text-18--alexandria
				${textColor}

				w-full
				`}>
					{text}
				</p>
			</div>
		</div>
	);
}

export default Benefits;
